import { collection, getDocs, query, where, writeBatch, doc, arrayUnion } from "firebase/firestore";
import { db } from "../firebase/config";
import { getSeasons } from "../teams/TeamProvider";
function isOutdoor(season) {
    return season.name.trim().toLowerCase() === "outdoor";
}
function isSchool(team) {
    return team.level === "school" || team.level === "college";
}
export async function queryPreviousAthletes(team, currentSeason, numOfPreviousYears = 3) {
    const rosterCollection = collection(db, "teams", team.id, "roster");
    let previousAthletesQuery;
    if (isSchool(team)) {
        const year = currentSeason.year + (isOutdoor(currentSeason) ? 0 : 1);
        previousAthletesQuery = query(rosterCollection, where("classOf", ">=", year), where("classOf", "<", year + numOfPreviousYears));
    }
    else {
        const year = currentSeason.year - (numOfPreviousYears + (isOutdoor(currentSeason) ? 1 : 0));
        const seasonIds = getSeasons(team.seasons)
            .filter((season) => season.year > year && season.id !== currentSeason.id)
            .map((season) => season.id);
        previousAthletesQuery = seasonIds.length === 0
            ? query(rosterCollection)
            : seasonIds.length === 1
                ? query(rosterCollection, where("seasons", "array-contains", seasonIds[0]))
                : query(rosterCollection, where("seasons", "array-contains-any", seasonIds));
    }
    const snapshot = await getDocs(previousAthletesQuery);
    return snapshot.docs
        .map((athleteDocument) => {
        const data = athleteDocument.data();
        return {
            id: athleteDocument.id,
            firstName: data.firstName ?? "",
            lastName: data.lastName ?? "",
            classOf: Number(data.classOf),
            seasons: Array.isArray(data.seasons) ? data.seasons : [],
            type: data.type ?? "Other",
            photo: data.photo,
        };
    })
        .filter((athlete) => !athlete.seasons.includes(currentSeason.id))
        .sort((left, right) => left.lastName.localeCompare(right.lastName) || left.firstName.localeCompare(right.firstName));
}
export async function appendSeasonToAthletes(teamId, athleteIds, seasonId) {
    for (let start = 0; start < athleteIds.length; start += 450) {
        const batch = writeBatch(db);
        athleteIds.slice(start, start + 450).forEach((athleteId) => {
            batch.update(doc(db, "teams", teamId, "roster", athleteId), { seasons: arrayUnion(seasonId) });
        });
        await batch.commit();
    }
}
